module.exports = __webpack_public_path__ + "video-play.png?288308b2037f409d293916c7a3913f20";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/video-play.png
// module id = 528
// module chunks = 2